import { FedexServiceEnum } from "@/constants/enums/fedexService.enum";

const FEDEX_FREIGHT_SERVICE_TYPES_INTERNAL: ReadonlySet<FedexServiceEnum> = new Set([
  FedexServiceEnum.FEDEX_1_DAY_FREIGHT,
  FedexServiceEnum.FEDEX_2_DAY_FREIGHT,
  FedexServiceEnum.FEDEX_3_DAY_FREIGHT,
  FedexServiceEnum.FEDEX_PRIORITY_EXPRESS_FREIGHT,
  FedexServiceEnum.FEDEX_PRIORITY_FREIGHT,
  FedexServiceEnum.INTERNATIONAL_PRIORITY_FREIGHT,
  FedexServiceEnum.INTERNATIONAL_ECONOMY_FREIGHT,
  FedexServiceEnum.FEDEX_REGIONAL_ECONOMY_FREIGHT,
]);

export const isFedexFreightServiceType = (
  serviceType: FedexServiceEnum | null | undefined,
): boolean => (serviceType ? FEDEX_FREIGHT_SERVICE_TYPES_INTERNAL.has(serviceType) : false);
